import { mapGetters } from "vuex";
export default {
  computed: {
    uom() {
      let res = "";

      if (this.uoms && (this.source || this.dataType)) {
        res = this.uoms.find(
          (x) => x.dataType === this.dataType || x.source === this.source
        );
        if (res) {
          res = res.uom;
        }
      }

      return res;
    },
    metadatum() {
      let res = "";
      if (this.metadata && (this.source || this.dataType)) {
        res = this.metadata.find(
          (x) => x.dataType === this.dataType || x.source === this.source
        );
        if (res) {
          res = res || null;
        }
      }
      return res;
    },
    ...mapGetters({
      uoms: "ui/uom",
      metadata: "ui/metadata",
      dataType: "ui/dataType",
      source: "ui/source",
    }),
  },
};
